export const ADD_SERVICE = 'ADD_SERVICE';
export const ADD_SERVICE_CHANGES = 'ADD_SERVICE_CHANGES';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const EDIT_SERVICE = 'EDIT_SERVICE';
export const END_SERVICE_EDITING = 'END_SERVICE_EDITING';
export const CHANGE_SERVICE_FIELD = 'CHANGE_SERVICE_FIELD';
